import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDoctorMale = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.58008 7C7.58008 7.57453 7.69324 8.14344 7.91311 8.67424C8.13297 9.20504 8.45523 9.68734 8.86149 10.0936C9.26774 10.4998 9.75004 10.8221 10.2808 11.042C10.8116 11.2618 11.3805 11.375 11.9551 11.375C12.5296 11.375 13.0985 11.2618 13.6293 11.042C14.1601 10.8221 14.6424 10.4998 15.0487 10.0936C15.4549 9.68734 15.7772 9.20504 15.9971 8.67424C16.2169 8.14344 16.3301 7.57453 16.3301 7C16.3301 6.42547 16.2169 5.85656 15.9971 5.32576C15.7772 4.79496 15.4549 4.31266 15.0487 3.90641C14.6424 3.50015 14.1601 3.17789 13.6293 2.95803C13.0985 2.73816 12.5296 2.625 11.9551 2.625C11.3805 2.625 10.8116 2.73816 10.2808 2.95803C9.75004 3.17789 9.26774 3.50015 8.86149 3.90641C8.45523 4.31266 8.13297 4.79496 7.91311 5.32576C7.69324 5.85656 7.58008 6.42547 7.58008 7V7Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.19751 4.79166C8.87495 5.49089 9.6861 6.04673 10.5827 6.42611C11.4793 6.80549 12.4431 7.00065 13.4167 6.99999C14.3988 7.00097 15.371 6.80252 16.2742 6.41666"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.83337 21.375C3.83337 19.2201 4.6894 17.1535 6.21313 15.6298C7.73686 14.106 9.80349 13.25 11.9584 13.25C14.1133 13.25 16.1799 14.106 17.7036 15.6298C19.2273 17.1535 20.0834 19.2201 20.0834 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5801 21.375V13.275"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58008 17.625H10.0801"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.83008 16.375V18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDoctorMale.displayName = 'SvgDoctorMale';
export default SvgDoctorMale;
